import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import PostcodeChecker from '../components/PostcodeChecker';
import DeliveryInfo from '../components/DeliveryInfo';
import './DeliveryPage.css';

function DeliveryPage() {
  return (
    <div className="delivery-page">
      <SEO
        title="Delivery Zones and Freight"
        description="Free delivery to most of Melbourne, $150 flat to the outer suburbs, and freight quoted elsewhere in Australia. Check your postcode and read the delivery terms."
        keywords="ASG Shading delivery, awning delivery Melbourne, delivery zones, freight quote"
        canonical="/delivery"
        jsonLd={[SEO.localBusinessSchema, SEO.breadcrumbSchema([{ name: 'Delivery' }]), SEO.webPageSchema({ type: 'WebPage', name: 'Delivery', description: 'ASG Shading delivery zones and terms.', url: '/delivery' })]}
      />
      <section className="dp-hero">
        <div className="dp-hero-content">
          <p className="dp-label">Delivery</p>
          <h1 className="dp-title">Delivery across Australia</h1>
          <p className="dp-subtitle">Free delivery to most of Melbourne, a flat $150 to the outer suburbs, and freight quoted anywhere else - always confirmed before we charge you.</p>
        </div>
      </section>

      <Breadcrumbs items={[{ name: 'Delivery' }]} />

      <section className="dp-main">
        <div className="dp-inner">
          <p className="dp-intro">
            We are based in Hoppers Crossing and deliver Melbourne orders ourselves. For the
            rest of Australia we ship with freight carriers and quote the cost per order.
            Enter your postcode to see which zone you are in:
          </p>

          <PostcodeChecker />

          <DeliveryInfo showZones headingLevel={2} />

          <p className="dp-quote-note">
            Outside our flat-rate zones? <Link to="/request-quote">Request a quote</Link> and we
            will confirm the freight cost for your postcode before you pay a cent.
          </p>
        </div>
      </section>
    </div>
  );
}

export default DeliveryPage;
